<template>
    <div class="item" style="text-align: left; padding: 10pt 10pt 10pt 15pt;color: white"
         :style="{'background-color':selected?'rgba(74, 74, 74, 0.6)':undefined}"
    >
        <div v-if="buttons&&buttons.length"
             class="right floated content"
             style="margin: 0;min-width: 28px;min-height: 28px">
            <div style="display: flex;flex-direction:column-reverse ">
                <v-btn flat icon color="blue-grey lighten-4"
                       v-for="button in buttons"
                       v-if="!button.condition||button.condition(item)"
                       small
                       :key="button.icon"
                       :style="{'margin':'0px','margin-bottom':'8px'}"
                       @click.stop="onButtonClick(button)"
                       :title="button.title"
                >
                    <v-icon :style="{'font-size': '18px'}">{{button.icon}}</v-icon>
                </v-btn>
            </div>
        </div>

        <div class="content" style="display: flex;align-items: center">
            <div style="padding-right: 10px"
                 v-if="checkable">
                <v-checkbox
                        color="blue darken-1"
                        dark
                        :value="item.id"
                        v-model="checked"
                />
            </div>
            <div @click="onContentClick" style="width: 100%">
                <slot :item="item"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'

    import {clone, isEqual} from 'lodash/lang'

    export default {
        props: {
            item: {
                type: Object,
                required: true
            },
            selected: {
                type: Boolean,
                default: false
            },
            buttons: {
                type: Array,
                default: () => []
            },
            checkable: {
                type: Boolean,
                default: false
            },
            checkedItems: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                checked: clone(this.checkedItems)
            }
        },
        computed: {},
        methods: {
            onButtonClick(button) {
                if (button.onClick)
                    button.onClick(this.item.id);
            },
            onContentClick() {
                this.$emit('click')
            }
        },
        components: {},
        watch: {
            checked(newVal) {
                this.$emit('update:checkedItems', clone(newVal));
            },
            checkedItems(newVal) {
                if (!isEqual(this.checked, newVal))
                    this.checked = clone(newVal);
            }
        }
    }
</script>

<style scoped>

</style>
